import { handleResponse, handleError } from "./apiUtils";
const url = process.env.REACT_APP_DOCUMENTS_API_URL;
const env = process.env.REACT_APP_ENV;

export async function getDocuments(documentRequestData) {

  // 3/22/24 - disable verification for non-production environments
//   if (env === 'dev' || env === 'stage') {
//     console.log('Documents API is disabled for environment: ' + env);
//     return true;
//   }

  try {
      let response = await fetch(url, {
        mode: "cors",
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(documentRequestData),
      });
      return handleResponse(response);

    // return [{"Id":0, "MemberId": "", "GroupId": "123456", "PlanYear": "2025", "DocumentName": "Document12345", "DocumentPath": "/Documents/2025/SampleSerializedPDF.txt"},
    //         {"Id":2, "MemberId": "", "GroupId": "123456", "PlanYear": "2026", "DocumentName": "Document98765", "DocumentPath": "/Documents/2026/SampleSerializedPDF.txt"}];

    } catch (error) {
      // console.log(error.)
      return handleError(error);
    }
    
}
